import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-tous-cmd',
  templateUrl: './tous-cmd.component.html',
  styleUrls: ['./tous-cmd.component.scss']
})
export class TousCmdComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('TousCmdComponent initialized');
        this.dataService.filterOrdersByStatus('Tous');
    }

}
